import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";

export class GameOverLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        const darkLayer = new Phaser.GameObjects.Graphics(this.scene);
        darkLayer.fillStyle(0x131538, .8);
        darkLayer.setInteractive();
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        darkLayer.alpha = 0;
        this.add(darkLayer);

        const scaledItemsContainer = new Phaser.GameObjects.Container(this.scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;
        this.add(scaledItemsContainer);

        const gameOverLabel = new Phaser.GameObjects.Image(this.scene, 0, -200, "texture_atlas_2_" + GameVars.gameData.language, "text_gameover");
        gameOverLabel.setOrigin(.5);
        gameOverLabel.setScale(.65);
        gameOverLabel.alpha = 0;
        scaledItemsContainer.add(gameOverLabel);

        const itemsShownWithDelayContainer = new Phaser.GameObjects.Container(this.scene);
        itemsShownWithDelayContainer.alpha = 0;
        scaledItemsContainer.add(itemsShownWithDelayContainer);

        const scoreXOffset = 20;

        const scoreLabel = new Phaser.GameObjects.Text(this.scene, -scoreXOffset, -90, GameVars.padNumberToString(GameVars.formatNumber(GameVars.score)), { fontFamily: "Sarpanch-Black", fontSize: "60px", color: "#fcff00" });
        scoreLabel.setOrigin(.5);
        scoreLabel.setStroke("#ffd71c", 2);
        scoreLabel.setShadow(0, 0, "#ff9000", 12.5, true, true);
        itemsShownWithDelayContainer.add(scoreLabel);

        const scoreIcon = new Phaser.GameObjects.Image(this.scene, scoreLabel.x + (scoreLabel.width * .5), scoreLabel.y, "texture_atlas_1", "icon_score");
        scoreIcon.setOrigin(0, .5);
        itemsShownWithDelayContainer.add(scoreIcon);

        const mazeLabel = new Phaser.GameObjects.Text(this.scene, 0, -35, GameVars.languages[GameVars.gameData.language]["MAZE"] + " " + GameVars.currentLevel, { fontFamily: "Sarpanch-Black", fontSize: "48px", color: "#7cfdff" });
        mazeLabel.setOrigin(.5);
        mazeLabel.setShadow(0, 0, "#b2fcff", 16.5, true, true);
        itemsShownWithDelayContainer.add(mazeLabel);

        const restartButton = new Button(this.scene, 0, 130, "texture_atlas_2_" + GameVars.gameData.language, "btn_restart_off", "btn_restart_on");
        restartButton.setOrigin(.5);
        restartButton.setInflationTween(1.1, 1, 1);
        restartButton.onUp(this.onRestart, this);
        itemsShownWithDelayContainer.add(restartButton);

        const exitButton = new Button(this.scene, 0, 200, "texture_atlas_2_" + GameVars.gameData.language, "btn_exit_game_off", "btn_exit_game_on");
        exitButton.setOrigin(.5);
        exitButton.setInflationTween(1.1, 1, 1);
        exitButton.onUp(this.onExit, this);
        itemsShownWithDelayContainer.add(exitButton);

        const highScoreLabel = new Phaser.GameObjects.Text(this.scene, -scoreXOffset, (GameConstants.GAME_HEIGHT / 2 - 30) / GameVars.scaleY, GameVars.languages[GameVars.gameData.language]["BEST SCORE"] + " " + GameVars.padNumberToString(GameVars.formatNumber(GameVars.gameData.highScore)), { fontFamily: "Sarpanch-Black", fontSize: "28px", color: "#fcff00" });
        highScoreLabel.setOrigin(.5);
        highScoreLabel.setStroke("#ffd71c", 2);
        highScoreLabel.setShadow(0, 0, "#ff9000", 8.5, true, true);
        itemsShownWithDelayContainer.add(highScoreLabel);

        const highScoreIcon = new Phaser.GameObjects.Image(this.scene, highScoreLabel.x + (highScoreLabel.width * .5), highScoreLabel.y, "texture_atlas_1", "icon_score");
        highScoreIcon.setOrigin(0, .5);
        highScoreIcon.setScale(.7);
        itemsShownWithDelayContainer.add(highScoreIcon);

        this.scene.tweens.add({
            targets: darkLayer,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            delay: 750
        });

        this.scene.tweens.add({
            targets: gameOverLabel,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 1250
        });

        this.scene.tweens.add({
            targets: itemsShownWithDelayContainer,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            delay: 1750
        });
    }

    private onRestart(): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "Reset";
            } else {
                GameManager.enterMazeScene();
            }
        } else {
            GameManager.enterMazeScene();
        }

        AudioManager.playSound("click");
    }

    private onExit(): void {

        if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
            if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                gdsdk.showAd();
                GameVars.typeAd = "MainMenu";
            } else {
                GameManager.enterSplash();
            }
        } else {
            GameManager.enterSplash();
        }

        AudioManager.playSound("click");
    }
}
